module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Foreword_1#u4NcWGMn2DjyhFrVkAkK2r3"
    }
  }, [_vm._v("Foreword by Burl Barer")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Foreword_2#u9qK3lmXteXcFnJei6iagg2"
    }
  }, [_vm._v("Foreword by Branka DiGangi")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Intro#uEngWZqjKcxgUdMjV5wG839"
    }
  }, [_vm._v("Introduction by Paul “Punch” Stanimirovic")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_01#u3277MqvNLqez4pOITy5ET8"
    }
  }, [_vm._v("Chapter One - Mr. Stan")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_02#ulU2zhe4CFlABad36TE6JY7"
    }
  }, [_vm._v("Chapter Two - Branka")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_03#uWCuL3zTz3xMcxALAJo2M72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three - The Protection Scam")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_04#uNMe8V9i9vrHoC55leGAIVC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four - Vizcaya")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_05#u7caOLJSxAcHtFIpRGaz7O8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five - Birth of a Bandit")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_06#uxpvOFCXpXypkADTSnuIQD2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six - The Home Invasion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_07#ur3f8sSUhmlSdtFfcSdzIs8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven - Joan Crawford")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_08#uOceJNTWgifnPgUGqzUZFsB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight - Alek “The Moth”")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_09#uIHi27wCxLU4O8GTQLaNfe4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine - Bosko")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_10#uh4AYA8QQ7br77CNbhuH8GE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten - Swiss Education")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_11#uNO8SooDkQ9OPSlPOMs89z3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven - The Gotti Heist")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_12#ufCBKkTCLcLlrKKMlMSoW2E",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve - The Big Deal")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_13#uRX7H6yHJIHrWbkAeCsruu8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen - Custom Built Son")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_14#ugPsAi7ADnLQnqVgTJHuRJC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen - Back to the Diamond District")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_15#ujrvYtiAWvDSI44icLbzVP8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen - Paul’s First Heist")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_16#uis2tTWNEzYnjK4vOfzmMzC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen - Mr. Stan and Son")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_17#uT5IUvdVqRXYHdz5DAoeCCF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen - Running from New Jersey")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_18#uk57Vu7uvLsGd5iLXKmlAt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen - Becoming Punch")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Pictures",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pictures")]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_19#uhThkkXylOv6ZoovxdJU5tA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen - Tension in the Family")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_20#uDBPlVSheLxlrWTjzFSpJp9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty - Off the Rails")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_21#uYJiUlN6wqbO65D565vbwFH",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One - The Warning")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_22#uhhTMppbCbxgDeHyvVSMGs7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two - Something Spectacular")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_23#uNUOyhAS6ohKcLJdrWsLb7F",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three - Carlos and Alarms")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_24#uHgdGalcWtoxVPe5oJf5sX2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four - Operation El Dorado")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_25#ubliGYCSNCA5WnN9iJi2YPF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five - Meet Mr. Lacka")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_26#uTZCHLmVirYGookfNC65n34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six - The Mega Heists")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_27#uO6HaJTOpF8ZhLR2XKeRtW5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven - The Serbian Mafia")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_28#uYuBXXemaxt3wVopcJKC33E",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight - New York Nightlife")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_29#ugTgcWjx7IaHeVsoqV9kFL5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Nine - The Regency Hotel Heist")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_30#uhULQFm3zms5ayzb4pJWok6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty - 1992")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_31#uWKa4ovSqveSqssZunpbkaD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-One - The Winds of Change")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_32#ujelWbgrlGgpVGeKCYiajX9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Two - The “head out the window” arrest")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_33#u2BTcoWWEqnlMEXBLE7HURB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Three - The Professor")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_34#u9PV969rdVnsAO6iKKTRw89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Four - Nightmare in a Bathtub")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_35#uIvUvmUNA3wiuxbfcEZeHc8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Five - Prison")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_36#uiznotE7hG4T8ZxzHYGIQwG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Six - The Incarceration Process")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_37#uI9SFrfhBOg5nBf3AoY9mIH",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Seven - Everything is Altered")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97f42f88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0